module.exports = __webpack_public_path__ + "img/05-ui-app-notice-mockup.48b983a9.webp";